var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('img',{staticClass:"poster",attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }